import { useTranslation } from 'react-i18next';
import Image from 'next/image';
import { i18n } from 'next-i18next';

import LeadButton from '@/components/LeadButton';
import Title from '@/components/Title';

const CourseFeatures = () => {
  const { t } = useTranslation(['home', 'english', 'path']);
  // const countrys = [
  //   {
  //     label: t('english:美国'),
  //     icon: '/images/english/countrys/us.svg',
  //   },
  //   {
  //     label: t('english:加拿大'),
  //     icon: '/images/english/countrys/au.svg',
  //   },
  //   {
  //     label: t('english:澳大利亚'),
  //     icon: '/images/english/countrys/au.svg',
  //   },
  //   {
  //     label: t('english:英国'),
  //     icon: '/images/english/countrys/uk.svg',
  //   },
  //   {
  //     label: t('english:新西兰'),
  //     icon: '/images/english/countrys/nz.svg',
  //   },
  //   {
  //     label: t('english:新加坡'),
  //     icon: '/images/english/countrys/sig.svg',
  //   },
  // ];
  return (
    <div className="relative mt-[5rem] text-center lg:mt-[140px] xl:mt-[200px]">
      <div className="container">
        <Title htmlLabel="h2" innerHTML className="mb-[4px] tracking-[0.96px] lg:mb-0" theme="english">
          {t('english:读写课堂')}
        </Title>
        {i18n?.language === 'zh' && (
          <Title htmlLabel="h1" innerHTML theme="english">
            {t('english:创意思维')}
          </Title>
        )}
        {/* <p
          className={`${i18n?.language === 'en' ? 'italic' : ''} mt-[1.5rem] text-[18px] font-normal text-wk-words-1 lg:mt-[24px] xl:mt-[40px]`}
        >
          {t('english:教育部大纲')}
        </p> */}
        {/* <div className="mt-[0.75rem] flex flex-wrap justify-center lg:mt-[16px] xl:mt-[16px]">
          {countrys.map((item, index) => {
            return (
              <span className={`flex items-center ${i18n?.language === 'en' ? 'italic' : ''}`} key={index}>
                {item.label}
                <img className="ml-[4px]" src={item.icon} alt="" />
                <span className="ml-[0.62rem] mr-[0.62rem] h-[16px] border-r-[1px] border-[#C6C7D2] lg:ml-[16px] lg:mr-[16px] xl:ml-[16px] xl:mr-[16px]" />
              </span>
            );
          })}
          <span className={`${i18n?.language === 'en' ? 'italic' : ''}`}>
            {i18n?.language === 'en' ? 'and more' : '...'}
          </span>
        </div> */}
        <section className="mb-[0.75rem] mt-[1.5rem] flex flex-wrap justify-center lg:mb-[20px]  lg:mt-[24px] xl:mb-[48px] xl:mt-[40px]">
          {i18n?.language === 'zh' && (
            <h3 className="mb-[0.75rem] mr-[0.75rem] flex items-center rounded-[999px] bg-[linear-gradient(89deg,rgba(134,66,248,0.12)_0.83%,rgba(0,163,254,0.12)_99.22%),linear-gradient(180deg,rgba(255,255,255,0.40)_0%,rgba(255,255,255,0.90)_100%)] p-[4px_12px] text-sm text-wk-words-1 lg:mr-[20px] lg:text-base  xl:mr-[24px] xl:text-[20px]">
              {/* <img src="/images/english/icon1.svg" alt="" className="mr-[12px] w-[20px] lg:mr-[8px]" /> */}
              {t('english:名师真人授课')}
            </h3>
          )}
          <h3 className="mb-[0.75rem] mr-[0.75rem] flex items-center rounded-[999px] bg-[linear-gradient(89deg,rgba(134,66,248,0.12)_0.83%,rgba(0,163,254,0.12)_99.22%),linear-gradient(180deg,rgba(255,255,255,0.40)_0%,rgba(255,255,255,0.90)_100%)] p-[4px_12px] text-sm text-wk-words-1 lg:mr-[20px] lg:text-base  xl:mr-[24px] xl:text-[20px]">
            {/* <img src="/images/english/icon1.svg" alt="" className="mr-[12px] w-[20px] lg:mr-[8px] xl:mr-[12px]" /> */}
            {t('english:高频互动在线小班')}
          </h3>
          <h3 className="mb-[0.75rem] mr-[0.75rem] flex items-center rounded-[999px] bg-[linear-gradient(89deg,rgba(134,66,248,0.12)_0.83%,rgba(0,163,254,0.12)_99.22%),linear-gradient(180deg,rgba(255,255,255,0.40)_0%,rgba(255,255,255,0.90)_100%)] p-[4px_12px] text-sm text-wk-words-1 lg:mr-[20px] lg:text-base  xl:mr-[24px] xl:text-[20px]">
            {/* <img src="/images/english/icon1.svg" alt="" className="mr-[12px] w-[20px] lg:mr-[8px] xl:mr-[12px]" /> */}
            {t('english:科学分级的版权课程')}
          </h3>
          <h3 className="mb-[0.75rem] mr-[0.75rem] flex items-center rounded-[999px] bg-[linear-gradient(89deg,rgba(134,66,248,0.12)_0.83%,rgba(0,163,254,0.12)_99.22%),linear-gradient(180deg,rgba(255,255,255,0.40)_0%,rgba(255,255,255,0.90)_100%)] p-[4px_12px] text-sm text-wk-words-1 lg:mr-[20px] lg:text-base  xl:mr-[24px] xl:text-[20px]">
            {/* <img src="/images/english/icon1.svg" alt="" className="mr-[12px] w-[20px] lg:mr-[8px] xl:mr-[12px]" /> */}
            {t('english:全英文母语沉浸式教学')}
          </h3>
          <h3 className="mb-[0.75rem] flex items-center rounded-[999px] bg-[linear-gradient(89deg,rgba(134,66,248,0.12)_0.83%,rgba(0,163,254,0.12)_99.22%),linear-gradient(180deg,rgba(255,255,255,0.40)_0%,rgba(255,255,255,0.90)_100%)] p-[4px_12px] text-sm text-wk-words-1 lg:text-base    xl:text-[20px]">
            {/* <img src="/images/english/icon1.svg" alt="" className="mr-[12px] w-[20px] lg:mr-[8px] xl:mr-[12px]" /> */}
            {t('english:覆盖全球24个时区')}
          </h3>
        </section>
        <div className="mx-auto flex items-center justify-center">
          <Image
            alt={t('english:seo-悟空高级英文阅读与写作课堂')}
            width={1400}
            height={855}
            src="/images/english/ipad.png"
            quality={100}
          />
        </div>
        <div className="mt-[1.62rem] lg:mt-[12px] xl:mt-[12px]">
          <LeadButton
            subject="english"
            theme="english"
            size="xl"
            traceName="O_EnglishCourse_ClassroomIntroduction_CTAClick"
            traceGa4Name="new_entry_EnglishCourse_ClassroomVideoCTA"
          >
            {t('english:立即体验')}
          </LeadButton>
        </div>
      </div>
    </div>
  );
};

export default CourseFeatures;
